module.exports = __webpack_public_path__ + "img/h1.dac0b68d.webp";